export class BackupAudit{
    public AuditGUID:string = '';
    public JSONAudit:string = '';
    public AuditID:number = -1;
    public LocationID:number=-1;
    public MachineGUID:string='';
    constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}